module.exports = __webpack_public_path__ + "static/thumbnail-8e64882ae4b965f0fb8cd35addc87c90.jpg";